module.exports = __webpack_public_path__ + "img/pay.d0a197ee.svg";